<script setup>
import { HrSpinner } from '../primitives';

/**
 * Activity spinner — dots animation for background operations within an already-loaded view.
 *
 * @status recommended
 * @group status-feedback
 * @useWhen An async operation is running in the background (autosave, processing, streaming)
 * @avoidWhen A full page or section is loading its primary content — use HrLoadingSpinner
 * @related HrLoadingSpinner
 */
defineOptions({ name: 'HrActivitySpinner' });

defineProps({
  /** Spinner size; accepts CSS length values (e.g. `'16px'`, `'2em'`). Defaults to the theme standard. */
  size: {
    type: String,
    default: undefined,
  },
  /**
   * Legacy props forwarded to the underlying Quasar component.
   * @deprecated Only for backwards compatibility with the legacy theme — ignored when a design system theme is active.
   */
  legacyProps: {
    type: Object,
    default: () => ({ color: 'primary' }),
  },
});
</script>

<template>
  <hr-spinner
    type="dots"
    :size="size"
    :legacy-props="legacyProps"
  />
</template>
